import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AangifteRapport} from '@snelstart-ventures/fiscaal/domain-logic';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-spec-scholing',
    templateUrl: './spec-scholing.component.html',
    styleUrls: ['./spec-scholing.component.scss'],
    imports: [SharedUiFormControlsModule, SharedUiDetailsModule, CommonModule],
})
export class SpecScholingComponent implements OnChanges {
    @Input() public id!: string;
    @Input({ required: true }) public rapport!: AangifteRapport;

    specScholingFormGroup = new FormGroup({
        specificatieScholing: new FormGroup({
            opbouw: new FormGroup({
                terugbetaaldePrestatiebeursAangever: new FormControl<number | null>(0),
                terugbetaaldePrestatiebeursPartner: new FormControl<number | null>(0),
                ontvangenVergoedingenAangever: new FormControl<number | null>(0),
                ontvangenVergoedingenPartner: new FormControl<number | null>(0),
                totaalScholingsaftrek: new FormControl<number | null>(0),
                aandeelScholingsaftrek: new FormControl<number | null>(0),
                totaleUitgavenAangever: new FormControl<number | null>(0),
                drempelAangever: new FormControl<number | null>(0),
                aftrekbaarAangever: new FormControl<number | null>(0),
                totaleUitgavenPartner: new FormControl<number | null>(0),
                drempelPartner: new FormControl<number | null>(0),
                aftrekbaarPartner: new FormControl<number | null>(0),
            }),
        }),
    });

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['rapport'] && this.rapport) {
            this.specScholingFormGroup.patchValue(this.rapport, { emitEvent: false });
            this.disableFormGroup(this.specScholingFormGroup);
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }
}
